<template>
	<div class="page_warp">
		<div class="top_content" style="display: table;justify-content: space-between; margin-bottom: 10px">

			<div style="display: table-row;">
				<div class="flex flex-y-center orderPicker">费用类型：
					<div class="top_input2">
						<el-select v-model="checkType" placeholder="请选择" @change="getData()">
							<el-option label="全部" value=""> </el-option>
							<el-option label="高速费" value="0"> </el-option>
							<el-option label="路桥费" value="1"> </el-option>
							<el-option label="燃料费" value="2"> </el-option>
							<el-option label="维修费" value="3"> </el-option>
							<el-option label="停车费" value="4"> </el-option>
							<el-option label="其它费用" value="50"> </el-option>
						</el-select>
					</div>
					<div
						style="display: flex;width: 350px; height: 35px;padding: 0 0 0 15px;align-items: center;justify-content: flex-start;">
						发生时间：
						<el-date-picker style="width: 250px; height: 35px" v-model="dayArr" type="datetimerange"
							range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
							@change="getData" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
						</el-date-picker>
					</div>

					<div class="top_input3">
						<el-input type="text" placeholder="请输入" v-model="searchWord"></el-input>
					</div>
					<div class="search_btn" @click="getData">查询</div>
					<div class="add_btn mr-10" @click="add">添加</div>

				</div>
			</div>

			<div style="display: table-row;">
				<div class="orderNav flex flex-y-center cursor" v-if="orderNum">
					<p :class="[changeLorstatus == '' ? 'ac' : '']" @click="changeNav('')">
						全部
					</p>
					<p :class="[changeLorstatus == '0' ? 'ac' : '']" @click="changeNav('0')">
						待审批<span v-if="orderNum.unaudited > 0">{{ orderNum.unaudited }}</span>
					</p>
					<p :class="[changeLorstatus == '1' ? 'ac' : '']" @click="changeNav('1')">
						等付款<span v-if="orderNum.unpaid > 0">{{ orderNum.unpaid }}</span>
					</p>
					<p :class="[changeLorstatus == '2' ? 'ac' : '']" @click="changeNav('2')">
						已通过
					</p>
					<p :class="[changeLorstatus == '3' ? 'ac' : '']" @click="changeNav('3')">
						已驳回<span v-if="orderNum.reject > 0">{{ orderNum.reject }}</span>
					</p>
					<p :class="[changeLorstatus == '4' ? 'ac' : '']" @click="changeNav('4')">
						已付款
					</p>
				</div>
			</div>
		</div>
		<div class="bottom_content2">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" highlight-current-row @current-change="handleCurrentChange">
					<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
					<el-table-column prop="exoNo" label="审批单号" width="110"></el-table-column>
					<el-table-column prop="exoAdvanceUserName" label="发起人" width="120"></el-table-column>
					<el-table-column prop="vehNo" label="关联车辆" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiPayTime" label="支付时间" width="120"></el-table-column>
					<el-table-column prop="exoName" label="费用类型" width="120"></el-table-column>
					<el-table-column prop="exoAdvanceType" label="支付类型" width="120">
						<template #default="scope">
							<span v-if="scope.row.exoAdvanceType == '0'">公司定点费用</span>
							<span v-else-if="scope.row.exoAdvanceType == '1'">垫付</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="exoChkStatus" label="审核状态" width="120">
						<template #default="scope">
							<span v-if="scope.row.exoChkStatus == '0'" style="color: #E36A19;">未审核</span>
							<span v-else-if="scope.row.exoChkStatus == '1'">审核通过</span>
							<span v-else-if="scope.row.exoChkStatus == '2'" style="color: #E36A19;">审核驳回</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="exoEaStatus" label="报销状态" width="120">
						<template #default="scope">
							<span v-if="scope.row.exoAdvanceType == '0'">不用报销</span>
							<span v-else-if="scope.row.exoEaStatus == '0'" style="color: #E36A19;">未报销</span>
							<span v-else-if="scope.row.exoEaStatus == '1'">已报销</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="itemList[0].exoiCount" label="数量" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiSumPrice" label="金额" width="90"></el-table-column>
					<el-table-column prop="exoCretime" label="创建时间" width="120"></el-table-column>
					<el-table-column prop="exoOdrId" label="关联运单" width="150"></el-table-column>
					<el-table-column prop="itemList[0].exoiDescribe" label="费用说明" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiOdometer" label="表显里程" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiPayAddr" label="发生地址" width="300">
						<template #default="scope">
							<div class="cell-style">{{ scope.row.itemList[0].exoiPayAddr }}</div>
						</template>
					</el-table-column>
					<el-table-column width="180" fixed="right" label="操作">
						<template #default="scope">
							<span class="default_color pointer m-right10" v-on:click="detail(scope.row.exoId)">详情</span>
							<span
								v-if="scope.row.exoEaStatus == '0'&&scope.row.exoAdvanceType == '1'&&scope.row.exoChkStatus == '1'"
								class="defaultAC_color pointer m-right10"
								v-on:click="tobaoxiao(scope.row.exoId)">报销</span>
							<span v-if="scope.row.exoChkStatus == '0'" class="defaultAC_color pointer m-right10"
								v-on:click="handleAudits(scope.row.exoId)">审核</span>
							<span v-if="scope.row.exoChkStatus !== '1'" class="defaultAC_color pointer m-right10"
								v-on:click="del(scope.row.exoId)">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-around">
				<div style="font-size: 14px; display: inline-block">
					费用单量:<span style="color: red">{{ exoSumCount }}</span>，费用汇总:<span
						style="color: red">￥{{ exoSumMoney.toFixed(2) }}</span>，待审核费用：<span
						style="color: red">￥{{ exoWaitChkMoney.toFixed(2) }}</span>，待报销费用：<span
						style="color: red">￥{{ exoWaitPayMoney.toFixed(2) }}</span>
				</div>
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<el-dialog title="审核" v-model="isAudit" width="30%" center>
			<div class="mar-bot-20"><span style="color: red">*</span>审核意见</div>
			<div style="width: 100%; height: 80px">
				<el-input type="textarea" v-model="auditsRemark" placeholder="请输入审核意见"></el-input>
			</div>
			<div class="btn_warp">
				<div class="btn-outline1" @click="Auditssubmit(1)">不通过</div>
				<div class="btn-outline2" @click="Auditssubmit(0)">通过</div>
			</div>
		</el-dialog>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />

	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "shenpiManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();
			
			const currentRow = ref();

			const data = reactive({
				tableId: "roleManagementTable",
				ChkStatus: "",
				EaStatus: "",
				checkType: "",
				AdvanceType: "",
				isAudit: false,
				auditsexoId: "",
				auditsRemark: "",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				changeLorstatus: "", //运单进度：空为全部 0待接单，1进行中，2已完成，3已关闭，10待审核
				orderNum: null,
				dayArr: [],
				exoSumCount: 0,
				exoSumMoney: 0,
				exoWaitPayMoney: 0,
				exoWaitChkMoney: 0,
			});
			onMounted(() => {
				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight - 40;

					//data.dayArr = get24hoursRangeTime();
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							"bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				console.log(data.dayArr);
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					exoType: data.checkType, //费用类型
					exoOdrId: "", //运单号
					exoAdvanceType: data.AdvanceType, //0公司固定点费用；1垫付
					exoChkStatus: data.ChkStatus, //审核状态：0未审核；1通过；2不通过
					exoEaStatus: data.EaStatus, //报销状态：0未报销；1已报销
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderList, params);
				console.log(r);
				if (r.code === 0) {
					getOrderListCount();

					data.tableData = r.rows;
					data.totalCount = r.total;

					getListSum();//获取汇总统计数据
				}

			};

			//获取汇总统计数据
			const getListSum = async () => {

				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					exoType: data.checkType, //费用类型
					exoOdrId: "", //运单号
					exoAdvanceType: data.AdvanceType, //0公司固定点费用；1垫付
					exoChkStatus: data.ChkStatus, //审核状态：0未审核；1通过；2不通过
					exoEaStatus: data.EaStatus, //报销状态：0未报销；1已报销
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};

				const r = await proxy.$http.get(apiObj.expensesOrderSum, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.exoSumCount = r.odrCount;
					data.exoSumMoney = r.sumMoney;
					data.exoWaitPayMoney = r.eaMoney;
					data.exoWaitChkMoney = r.chkMoney;
				}

			};

			//获取审批状态数量
			const getOrderListCount = async () => {
				console.log(data.dayArr);
				let params = {
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderCount, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.orderNum = r;
					console.log(data.orderNum);
				}

			};

			const get24hoursRangeTime = () => {
				//当前设定的日期时间
				let rangeArr = []; //定义一个装时间的数组
				let d = new Date();
				let year1, month1, day1, hour1, minutes1, seconds1;
				year1 = d.getFullYear();
				month1 = d.getMonth() + 1;
				day1 = d.getDate();
				hour1 = d.getHours();
				minutes1 = d.getMinutes();
				seconds1 = d.getSeconds();
				month1 = month1 < 10 ? '0' + month1 : month1;
				day1 = day1 < 10 ? '0' + day1 : day1;
				hour1 = hour1 < 10 ? '0' + hour1 : hour1;
				minutes1 = minutes1 < 10 ? '0' + minutes1 : minutes1;
				seconds1 = seconds1 < 10 ? '0' + seconds1 : seconds1;
				let value1 = year1 + '-' + month1 + '-' + day1 + ' ' + hour1 + ':' + minutes1 + ':' + seconds1;
				rangeArr.push(value1);
				//前一天设定的日期时间
				let year2, month2, day2, hour2, minutes2, seconds2;
				//getTime() 返回距 1970 年 1 月 1 日之间的毫秒数,setTime设置 Date 对象的日期和时间值
				d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000); //减去一天的毫秒时间，就是前一天的了
				year2 = d.getFullYear();
				month2 = d.getMonth() + 1;
				day2 = d.getDate();
				hour2 = d.getHours();
				minutes2 = d.getMinutes();
				seconds2 = d.getSeconds();
				month2 = month2 < 10 ? '0' + month2 : month2;
				day2 = day2 < 10 ? '0' + day2 : day2;
				hour2 = hour2 < 10 ? '0' + hour2 : hour2;
				minutes2 = minutes2 < 10 ? '0' + minutes2 : minutes2;
				seconds2 = seconds2 < 10 ? '0' + seconds2 : seconds2;
				let value2 = year2 + '-' + month2 + '-' + day2 + ' ' + hour2 + ':' + minutes2 + ':' + seconds2;
				rangeArr.unshift(value2);
				return rangeArr;
			};

			// 添加 根目录
			const add = () => {
				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 审批费用详情
			const detail = (id) => {
				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};
			//费用删除
			const del = (id) => {
				proxy
					.$confirm("您确定删除选中的费用吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							exoId: id,
						};
						const r = await proxy.$http.postFormData(apiObj.expensesOrderRemove, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//菜单撤销
			const cancel = (lorId) => {
				proxy
					.$confirm("您确定撤销选中的运单吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
						};
						const r = await proxy.$http.postFormData(apiObj.ordCancel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//报销
			const tobaoxiao = (exoId) => {
				proxy
					.$confirm("您确定报销选中的费用吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							exoId: exoId,
						};
						const r = await proxy.$http.postFormData(apiObj.expensesOrderWriteOff, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//切换状态运单
			const changeNav = (val) => {

				if (val == '') {
					data.ChkStatus = "";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '0') {
					//待审批
					data.ChkStatus = "0";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '1') {
					//等付款
					data.ChkStatus = "1";
					data.EaStatus = "0";
					data.AdvanceType = "1";
				} else if (val == '2') {
					//已通过
					data.ChkStatus = "1";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '3') {
					//已驳回
					data.ChkStatus = "2";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '4') {
					//已付款
					data.ChkStatus = "";
					data.EaStatus = "1";
					data.AdvanceType = "1";
				}

				data.changeLorstatus = val;

				// this.currentPage = 1;
				// this.tableData = [];
				getData();
			};

			const handleAudits = (exoId) => {
				data.isAudit = true;
				data.auditsexoId = exoId;
				data.auditsRemark = "";
			};

			//审核
			const Auditssubmit = async (status) => {
				if (status == 1 && data.auditsRemark == "") {
					proxy.$message.error("请输入审核原因");
					return;
				}

				let params = {
					exoId: data.auditsexoId,
					operate: status, //操作类型：0通过，1不通过
					remark: data.auditsRemark
				};

				const r = await proxy.$http.postFormData(apiObj.expensesOrderExamine, params);
				if (r.respCode == 0 || r.respCode == "0000") {
					proxy.$message.success(r.msg || r.respMsg);
					data.isAudit = false;
					getData();
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};
			
			const handleCurrentChange = (val) => {
				currentRow.value = val
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				cancel,
				changeNav,
				tobaoxiao,
				handleAudits,
				Auditssubmit,
				handleCurrentChange,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.orderNav {
		/* width: 100%; */
		background: #ffffff;
		border-radius: 10px;
		height: 60px;
		font-size: 16px;
		color: #333;
		/* margin-bottom: 20px; */
	}

	.orderNav p {
		margin: 0 15px;
		position: relative;
	}

	.orderNav p.ac {
		color: #e36a19;
		cursor: pointer;
	}

	.orderNav p span {
		display: block;
		width: 20px;
		height: 20px;
		background: #ff0000;
		border-radius: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #fff;
		position: absolute;
		top: -10px;
		right: -10px;
	}

	.orderPicker {
		margin-top: 10px;
		height: 50px;
	}

	.orderPicker .el-range__icon {
		margin-right: 10px !important;
	}

	.cursor {
		cursor: pointer;
	}

	.btn-outline1 {
		background: #ff6600 !important;
	}

	.btn-outline2 {
		background: #2eb779 !important;
	}

	.btn_warp {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.btn_warp>div {
		width: 90px;
		height: 36px;
		border-radius: 6px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;
		text-align: center;
		line-height: 36px;
		margin-left: 20px;
	}

	.mar-bot-20 {
		margin-bottom: 20px !important;
	}

	.cell-style {
		white-space: nowrap;
		/* 防止内容换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略符号来代表被修剪的文本 */
	}
</style>